export default __webpack_public_path__ + "static/media/AfterPhoto2.bd806e1e.jpg";